"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.textFieldBorderRadius = exports.createEmotionCache = exports.theme = void 0;
const cache_1 = __importDefault(require("@emotion/cache"));
const material_1 = require("@mui/material");
const border_radii_1 = require("./theme/border-radii");
const components_1 = require("./theme/components");
const palette_1 = require("./theme/palette");
const shadows_1 = require("./theme/shadows");
const typography_1 = require("./theme/typography");
exports.theme = (0, material_1.createTheme)({
    palette: palette_1.palette,
    typography: typography_1.typography,
    shadows: shadows_1.shadows,
    borderRadii: border_radii_1.borderRadii,
    boxShadows: shadows_1.boxShadows,
    dropShadows: shadows_1.dropShadows,
    /** @todo: figure out how to properly override this type */
    components: components_1.components,
});
const createEmotionCache = (key) => (0, cache_1.default)({ key: key ?? "css" });
exports.createEmotionCache = createEmotionCache;
// @todo - consider re-exporting textFieldBorderRadius from another file
var mui_outlined_input_theme_options_1 = require("./theme/components/inputs/mui-outlined-input-theme-options");
Object.defineProperty(exports, "textFieldBorderRadius", { enumerable: true, get: function () { return mui_outlined_input_theme_options_1.textFieldBorderRadius; } });
__exportStar(require("./theme/palette"), exports);
